export default __webpack_public_path__ + "static/media/rightArrow.996809c9.svg";